import React, { useState } from 'react';
import { SlidingScale, MultipleChoiceQuestion } from '../../survey-tools/likert-scales';
import { Button , TextField, Typography} from "@mui/material";
import { connect } from 'react-redux';
import { nextTask } from '../../study-logic/study-redux-slice';
import {PageContainer} from "../../survey-tools/ui-components/containers"
import {CustomConfirmationDialog} from '../../survey-tools/custom-dialogue'; // Adjust the import path as needed

function ThinkAloudQuestions({ instanceId,nextTask }) {
    const [easeOfThinkingAloud, setEaseOfThinkingAloud] = useState(50);
    const [frequencyOfRunningOut, setFrequencyOfRunningOut] = useState('');
    const [similarityToDailyThoughts, setSimilarityToDailyThoughts] = useState(50);
    const [censorThoughts, setCensorThoughts] = useState(50);
    const [otherCommentsAudio, setOtherCommentsAudio] = useState('');
    const [showDialog, setShowDialog] = useState(false);
    const [EaseThinkingSliderMoved, setEaseThinkingSliderMoved] = useState(false); // State to track if the slider has been moved
    const [SimilarThoughtsSliderMoved, setSimilarThoughtsSliderMoved] = useState(false); // State to track if the slider has been moved
    const [CensorThoughtsSliderMoved, setCensorThoughtsSliderMoved] = useState(false); // State to track if the slider has been moved

    const isResponseIncomplete = () => {
        return !frequencyOfRunningOut || !EaseThinkingSliderMoved || !SimilarThoughtsSliderMoved || !CensorThoughtsSliderMoved;
    };

    const handleSubmit = () => {
        if (isResponseIncomplete()) {
            setShowDialog(true);
        } else {
            const data = {
                easeOfThinkingAloud,
                frequencyOfRunningOut,
                similarityToDailyThoughts,
                censorThoughts,
                otherCommentsAudio
            };
            // Dispatch action to save data
            console.log(data)
            nextTask({ data });
        }
    };

    const HandleEaseOfThinkingAloudChange = (newValue) => {
        if (!EaseThinkingSliderMoved) setEaseThinkingSliderMoved(true); // Update sliderMoved to true on first interaction
        setEaseOfThinkingAloud(newValue);

    };

    const HandleSimilarThoughtsChange = (newValue) => {
        if (!SimilarThoughtsSliderMoved) setSimilarThoughtsSliderMoved(true); // Update sliderMoved to true on first interaction
        setSimilarityToDailyThoughts(newValue);

    };

    const HandleCensorThoughtsChange = (newValue) => {
        if (!CensorThoughtsSliderMoved) setCensorThoughtsSliderMoved(true); // Update sliderMoved to true on first interaction
        setCensorThoughts(newValue);
    };




    return (
        <PageContainer>
        <div>


            <SlidingScale 
                question=<Typography gutterBottom>How easy was it for you to think-aloud for 10 minutes?</Typography>
                leftLabel="Not at all"
                rightLabel="Extremely"
                handleUpdate={HandleEaseOfThinkingAloudChange}
            />

            <div style={{ height: '30px' }}></div> 

            <MultipleChoiceQuestion 
                question="How often did you run out of things to say during the think-aloud exercise?"
                options={["Never", "Sometimes", "Often", "Almost Always"]} 
                handleUpdate={setFrequencyOfRunningOut}
            />

            <div style={{ height: '40px' }}></div> 

            <SlidingScale 
                question=<Typography gutterBottom>How similar were your thoughts to those you experience in your day-to-day life?</Typography>
                leftLabel="Not at all"
                rightLabel="Extremely"
                handleUpdate={HandleSimilarThoughtsChange}
            />

            <div style={{ height: '40px' }}></div> 


            <SlidingScale 
                question=<Typography gutterBottom>To what extent did you censor yourself during the task?</Typography>
                leftLabel="Not at all"
                rightLabel="As much as possible"
                handleUpdate={HandleCensorThoughtsChange}
            />

            <div style={{ height: '40px' }}></div> 

            <div>
            <Typography gutterBottom>
            Please feel free to share any other comments you have about the think-aloud exercise.
            </Typography>
            <TextField
            fullWidth={false}
            multiline
            rows={2}
            variant="outlined"
            value={otherCommentsAudio}
            onChange={(e) => setOtherCommentsAudio(e.target.value)}
            margin="normal"
            sx={{
            width: 700, // Custom width, adjust as needed
        }}
            />
            </div>

            <div style={{ height: '20px' }}></div> 

<Button variant="contained" onClick={handleSubmit}>Next</Button>
            <CustomConfirmationDialog
                open={showDialog}
                onClose={() => setShowDialog(false)}
                onConfirm={() => {
                    setShowDialog(false);

                    const data = {
                easeOfThinkingAloud,
                frequencyOfRunningOut,
                similarityToDailyThoughts,
                censorThoughts,
                otherCommentsAudio
            };
            
                    nextTask({ data });

                }}
            />        </div>
                </PageContainer>

    );
};

const mapDispatchToProps = { nextTask };
export default connect(null, mapDispatchToProps)(ThinkAloudQuestions);


